__turbopack_context__.v({
  "className": "fontseasonmix_5b2e6422-module__6nVWdG__className",
  "variable": "fontseasonmix_5b2e6422-module__6nVWdG__variable",
});
